import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import { getToken } from "@/utils/auth";
import { Message } from "element-ui";

import homePath from "@/views/index.vue";

Vue.use(VueRouter);

const router = new VueRouter({
  routes: [
    {
      path: "/",
      component: homePath,
      meta: { title: "首页" },
      children: [
        {
          path: "/",
          component: () => import("../views/home.vue"),
          meta: { title: "首页" },
        },
        {
          path: "/school",
          component: () => import("../views/school.vue"),
          meta: { title: "科学园地" },
        },
        {
          path: "/qixiang",
          component: () => import("../views/qixiang.vue"),
          meta: { title: "在线学习" },
          name: "onlineStudy",
        },
        {
          path: "/shop",
          component: () => import("../views/shop.vue"),
          meta: { title: "商城" },
        },
        {
          path: "/showShop",
          component: () => import("../views/showShop.vue"),
          meta: { title: "商城" },
        },
        {
          path: "/qixiang/showPpt",
          component: () => import("../views/showPpt.vue"),
          meta: { title: "课程PPT" },
          name: "study",
        },
        {
          path: "/qixiang/video",
          component: () => import("../views/video.vue"),
          meta: { title: "课程视频" },
          name: "video",
        },
        {
          path: "/science",
          component: () => import("../views/science.vue"),
          meta: { title: "科学活动" },
          name: "science",
        },
        {
          path: "/course",
          component: () => import("../views/course.vue"),
          meta: { title: "特色课程" },
          name: "course",
          children: [],
        },
        {
          path: "/course/intro",
          name: "courseIntro",
          component: () => import("../views/courseIntro.vue"),
          meta: { title: "气象STEM课程总体介绍" },
        },
        {
          path: "/reader",
          name: "reader",
          component: () => import("../views/file.vue"),
          meta: { title: "文章详情" },
        },
      ],
    },
    {
      name: "login",
      path: "/login",
      component: () => import("../views/login.vue"),
      meta: { title: "登录" },
    },
    {
      name: "signup",
      path: "/signup",
      component: () => import("../views/signup.vue"),
      meta: { title: "注册" },
    },
    {
      name: "signType",
      path: "/signType",
      component: () => import("../views/signType.vue"),
      meta: { title: "账号注册" },
    },
    {
      name: "resetPassword",
      path: "/resetPassword",
      component: () => import("../views/gis/resetPassword.vue"),
      meta: { title: "找回密码" },
    },
    {
      name: "pay",
      path: "/pay",
      component: () => import("../views/pay/pay.vue"),
      meta: { title: "vip" },
    },
    {
      name: "gis",
      path: "/gis",
      component: () => import("../views/gis/gishome.vue"),
      children: [
        {
          name: "map",
          path: "/map",
          component: () => import("../views/gis/gis.vue"),
          meta: { title: "科学观测网-GIS地图" },
        },
        {
          name: "detail",
          path: "/detail",
          component: () => import("../views/gis/gisdetail.vue"),
          meta: { title: "科学观测网-气象站" },
        },
        {
          name: "gisadd",
          path: "/gisadd",
          component: () => import("../views/gis/gisadd.vue"),
          meta: { title: "个人气象站新增", requiresAuth: true },
        },
        {
          name: "personal",
          path: "/personal",
          component: () => import("../views/gis/gispersonal.vue"),
          meta: { title: "个人气象站管理", requiresAuth: true },
        },
        {
          name: "gislist",
          path: "/gislist",
          component: () => import("../views/gis/gislist.vue"),
          meta: { title: "修改", requiresAuth: true },
        },
        {
          name: "gisuser",
          path: "/gisuser",
          component: () => import("../views/gis/gisuser.vue"),
          meta: { title: "user", requiresAuth: true },
        },
        {
          name: "site",
          path: "/site",
          component: () => import("../views/gis/gisSite.vue"),
        },
      ],
    },
    // 第三届校园大赛报名页面
    {
      name: "activity",
      path: "/activity",
      component: () => import("../views/activity/activity.vue"),
      meta: { title: "第三届校园气象观测和应用挑战赛" },
    },
    // 报名表
    {
      name: "signHome",
      path: "/signHome",
      component: () => import("../views/sign/signHome.vue"),
      meta: { title: "报名页面" },
      children: [
        {
          name: "info",
          path: "/info",
          component: () => import("../views/sign/info.vue"),
          meta: { title: "填写报名信息", requiresAuth: true },
        },
        {
          name: "uploadData",
          path: "/uploadData",
          component: () => import("../views/sign/uploadData.vue"),
          meta: { title: "上传气象数据", requiresAuth: true },
        },
        {
          name: "signList",
          path: "/signList",
          component: () => import("../views/sign/signList.vue"),
          meta: { title: "报名列表", requiresAuth: true },
        },
        {
          name: "review",
          path: "/review",
          component: () => import("../views/sign/review.vue"),
          meta: { title: "评审", requiresAuth: true, roles: [9, 91] },
        },
        {
          name: "templates",
          path: "/templates",
          component: () => import("../views/sign/templates.vue"),
          meta: { title: "模版下载" },
        },
      ],
    },
    // 管理后台
    {
      name: "adminIndex",
      path: "/admin/index",
      component: () => import("../views/admin/index.vue"),
      meta: { title: "首页", requiresAuth: true, roles: [9, 10] },
    },
    {
      name: "admin",
      path: "/admin",
      component: () => import("../views/admin/index.vue"),
      meta: { title: "首页", requiresAuth: true, roles: [9, 10] },
      children: [
        {
          name: "role",
          path: "role",
          component: () => import("../views/admin/system/role/index.vue"),
          meta: { title: "角色管理", requiresAuth: true, roles: [9, 10] },
        },
        {
          name: "menu",
          path: "menu",
          component: () => import("../views/admin/system/menu/index.vue"),
          meta: { title: "菜单管理", requiresAuth: true, roles: [9, 10] },
        },
        {
          name: "account",
          path: "account",
          component: () => import("../views/admin/system/user/index.vue"),
          meta: { title: "用户管理", requiresAuth: true, roles: [9, 10] },
        },
      ],
    },
    {
      name: "addminLogin",
      path: "/admin/login",
      component: () => import("../views/admin/login/index.vue"),
      meta: { title: "登录" },
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.title) {
    //判断是否有标题
    document.title = to.meta.title;
  }

  // 路由登录权限拦截
  const requiresAuth = to.matched.some(
    (record) => record.meta && record.meta.requiresAuth
  );
  if (requiresAuth) {
    const token = getToken();
    const userInfo = store.state.user && store.state.user.userInfo;
    const hasUserId = userInfo && userInfo.id;

    // 1. 未登录拦截
    if (!token || !hasUserId) {
      if (to.path.startsWith("/admin")) {
        next({
          path: "/admin/login",
          query: { redirect: to.fullPath },
        });
      } else {
        next({
          name: "login",
          query: { redirect: to.fullPath },
        });
      }
      return;
    }

    // 2. 管理后台路径角色拦截 (必须为管理员 9 或后台用户 10)
    if (to.path.startsWith("/admin") && to.path !== "/admin/login") {
      const userType = Number(userInfo.type);
      if (userType !== 9 && userType !== 10) {
        Message.error("您没有权限访问管理后台");
        next({ path: "/map" });
        return;
      }
    }

    // 3. 特定角色限制（如专家评审页面 roles: [9, 91]）
    const matchedWithRoles = to.matched.find(
      (record) => record.meta && Array.isArray(record.meta.roles)
    );
    if (matchedWithRoles) {
      const userType = Number(userInfo.type);
      const allowedRoles = matchedWithRoles.meta.roles;
      if (!allowedRoles.includes(userType)) {
        Message.error("您没有权限访问该页面");
        next({ path: "/map" });
        return;
      }
    }
  }

  next(); //执行进入路由，如果不写就不会进入目标页
});

export default router;
